import React, { Component } from 'react';
import './Occupied.css';

class Occupied extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []

    }
  }

  handleUserInput = (e) => {
  let update ={}; //11-01-18

  const set = name => {
    const value = e.target.value;
    update[name] = parseInt(value)
  }
    const name = e.target.name;
    set(name) 
    //restrict user 11-01-18
    if(e.target.type === 'number') {
      const min = parseInt(e.target.getAttribute('min'));
      const max = parseInt(e.target.getAttribute('max'));
      const value = parseInt(e.target.value);
      console.log(min, max, value);
      
      if (value < min || value > max) return false;
    }  //end restrict 11-01-18
    this.props.onOptionsUpdate(update);
  }

  render() {
    return (
      <div>
        <div>
          <p className="calendar_para"><i class="fas fa-clock green-icon"></i>&nbsp;<b>Occupied Number Days per Month and Hours per Day</b></p>
          <table className="tbl_calendardata">
            <tr>
            <th>Jan</th>
              <th>Feb</th>
              <th>Mar</th>
              <th>Apr</th>
              <th>May</th>
              <th>Jun</th>
              <th>Jul</th>
              <th>Aug</th>
              <th>Sep</th>
              <th>Oct</th>
              <th>Nov</th>
              <th>Dec</th>
            </tr>
            <tr>
              <td><label className="App-bold" htmlFor="janOccCalendar">days:</label>
                <input type="number"
                  name="janOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.janOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td><label className="App-bold" htmlFor="febOccCalendar">days:</label>
                <input type="number"
                  name="febOccCalendar"
                  min="0"
                  max="28"
                  step="1"
                  value={this.props.options.febOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>
                <label className="App-bold" htmlFor="marOccCalendar">days:</label>
                <input type="number"
                  name="marOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.marOccCalendar}
                  onChange={this.handleUserInput}
                />
              </td>
              <td>
                <label className="App-bold" htmlFor="aprOccCalendar">days:</label>
                <input type="number"
                  name="aprOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.aprOccCalendar}
                  onChange={this.handleUserInput}
                />
              </td>
              <td> <label className="App-bold" htmlFor="mayOccCalendar">days:</label>
                <input type="number"
                  name="mayOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.mayOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td><label className="App-bold" htmlFor="junOccCalendar">days:</label>
                <input type="number"
                  name="junOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.junOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlFor="julOccCalendar">days:</label>
                <input type="number"
                  name="julOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.julOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlFor="augOccCalendar">days:</label>
                <input type="number"
                  name="augOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.augOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlFor="sepOccCalendar">days:</label>
                <input type="number"
                  name="sepOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.sepOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>  <label className="App-bold" htmlFor="octOccCalendar">days:</label>
                <input type="number"
                  name="octOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.octOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td> <label className="App-bold" htmlFor="novOccCalendar">days:</label>
                <input type="number"
                  name="novOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.novOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
              <td>  <label className="App-bold" htmlFor="decOccCalendar">days:</label>
                <input type="number"
                  name="decOccCalendar"
                  min="0"
                  max="31"
                  step="1"
                  value={this.props.options.decOccCalendar}
                  onChange={this.handleUserInput}
                /></td>
            </tr>
            <tr>
              <td> <label className="App-bold" htmlFor="janOccHours">hrs:</label>
                <input type="number"
                  name="janOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.janOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="febOccHours">hrs:</label>
                <input type="number"
                  name="febOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.febOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="marOccHours">hrs:</label>
                <input type="number"
                  name="marOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.marOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="aprOccHours">hrs:</label>
                <input type="number"
                  name="aprOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.aprOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="mayOccHours">hrs:</label>
                <input type="number"
                  name="mayOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.mayOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="junOccHours">hrs:</label>
                <input type="number"
                  name="junOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.junOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="julOccHours">hrs:</label>
                <input type="number"
                  name="julOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.julOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="augOccHours">hrs:</label>
                <input type="number"
                  name="augOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.augOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td><label className="App-bold" htmlFor="sepOccHours">hrs:</label>
                <input type="number"
                  name="sepOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.sepOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="novOccHours">hrs:</label>
                <input type="number"
                  name="novOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.novOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="octOccHours">hrs:</label>
                <input type="number"
                  name="octOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.octOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
              <td> <label className="App-bold" htmlFor="decOccHours">hrs:</label>
                <input type="number"
                  name="decOccHours"
                  min="0"
                  max="24"
                  step="1"
                  value={this.props.options.decOccHours}
                  onChange={this.handleUserInput}
                  className="number_boxes"
                /></td>
            </tr>
          </table>
        </div>
      


      </div>
    );
  }
}

export default Occupied;


// WEBPACK FOOTER //
// ./src/components/Occupied.js